import { GET_DOMAIN } from '../actions/action_types';
import { console_log } from "../utils/helper";

const initialState = {
    domains: [],

};

export const DomainReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_DOMAIN:
            return {
                ...state,
                domains: action.data.data
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/DomainReducer.js